import { createAggregatedClient } from "@smithy/smithy-client";
import { AnalyzeDocumentCommand, } from "./commands/AnalyzeDocumentCommand";
import { AnalyzeExpenseCommand, } from "./commands/AnalyzeExpenseCommand";
import { AnalyzeIDCommand } from "./commands/AnalyzeIDCommand";
import { CreateAdapterCommand, } from "./commands/CreateAdapterCommand";
import { CreateAdapterVersionCommand, } from "./commands/CreateAdapterVersionCommand";
import { DeleteAdapterCommand, } from "./commands/DeleteAdapterCommand";
import { DeleteAdapterVersionCommand, } from "./commands/DeleteAdapterVersionCommand";
import { DetectDocumentTextCommand, } from "./commands/DetectDocumentTextCommand";
import { GetAdapterCommand } from "./commands/GetAdapterCommand";
import { GetAdapterVersionCommand, } from "./commands/GetAdapterVersionCommand";
import { GetDocumentAnalysisCommand, } from "./commands/GetDocumentAnalysisCommand";
import { GetDocumentTextDetectionCommand, } from "./commands/GetDocumentTextDetectionCommand";
import { GetExpenseAnalysisCommand, } from "./commands/GetExpenseAnalysisCommand";
import { GetLendingAnalysisCommand, } from "./commands/GetLendingAnalysisCommand";
import { GetLendingAnalysisSummaryCommand, } from "./commands/GetLendingAnalysisSummaryCommand";
import { ListAdaptersCommand, } from "./commands/ListAdaptersCommand";
import { ListAdapterVersionsCommand, } from "./commands/ListAdapterVersionsCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { StartDocumentAnalysisCommand, } from "./commands/StartDocumentAnalysisCommand";
import { StartDocumentTextDetectionCommand, } from "./commands/StartDocumentTextDetectionCommand";
import { StartExpenseAnalysisCommand, } from "./commands/StartExpenseAnalysisCommand";
import { StartLendingAnalysisCommand, } from "./commands/StartLendingAnalysisCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateAdapterCommand, } from "./commands/UpdateAdapterCommand";
import { TextractClient } from "./TextractClient";
const commands = {
    AnalyzeDocumentCommand,
    AnalyzeExpenseCommand,
    AnalyzeIDCommand,
    CreateAdapterCommand,
    CreateAdapterVersionCommand,
    DeleteAdapterCommand,
    DeleteAdapterVersionCommand,
    DetectDocumentTextCommand,
    GetAdapterCommand,
    GetAdapterVersionCommand,
    GetDocumentAnalysisCommand,
    GetDocumentTextDetectionCommand,
    GetExpenseAnalysisCommand,
    GetLendingAnalysisCommand,
    GetLendingAnalysisSummaryCommand,
    ListAdaptersCommand,
    ListAdapterVersionsCommand,
    ListTagsForResourceCommand,
    StartDocumentAnalysisCommand,
    StartDocumentTextDetectionCommand,
    StartExpenseAnalysisCommand,
    StartLendingAnalysisCommand,
    TagResourceCommand,
    UntagResourceCommand,
    UpdateAdapterCommand,
};
export class Textract extends TextractClient {
}
createAggregatedClient(commands, Textract);
